<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section">
        <div class="container">
          <div class="grid justify-content-between">
            <div class="col-12">
              <div class="">
                <div class="flex justify-content-between align-items-center px-2">
                  <div
                    class="mb-2"
                  >
                    <Button
                      icon="pi pi-arrow-left"
                      class="p-button-sm p-button-rounded px-4"
                      label="Back"
                      @click="
                        openPageDrawer(
                          {
                            page: `applicants/view`,
                            url: `/applicants/view/${pageData.applicantId}`,
                          },
                          { width: `40vw` }
                        )
                      "
                    />
                  </div>
                  <div
                    class="text-2xl text-primary font-bold"
                  >
                  Examination Results
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container">
        <div class="grid">
          <div class="col comp-grid">
            <div class="">
              <div>
                <div class="relative-position" style="min-height: 100px">
                  <template v-if="!loading && item">
                    <div class="row q-col-gutter-x-md">
                      <div class="col-12">
                        <div class="grid mt-2">
                          <div class="col-12">
                            <div class="card nice-shadow-6 mb-0 pt-3 pb-1">
                              <div class="mb-2">
                                <div class="grid">
                                  <div class="col-fixed">
                                    <img
                                      style="
                                        width: 50px;
                                        height: 50px;
                                        border-radius: 50%;
                                        overflow: hidden;
                                      "
                                      :src="$utils.setImgUrl(null, 'medium')"
                                    />
                                  </div>
                                  <div class="col">
                                    <div class="text-md text-primary mb-2">
                                      {{ item.cname }}
                                    </div>
                                    <div class="text-sm text-gray-500 mb-1">
                                      Date of Birth:
                                      {{ item.dob }}
                                    </div>
                                    <div class="text-sm text-gray-500 mb-1">
                                      Type of Exams:
                                      {{ item.examtype }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col-12">
                            <DataTable
                              :value="getItems(item.resultdetails)"
                              responsiveLayout="scroll"
                              breakpoint="960px"
                            >
                              <Column field="subjectcode" header="Subject Code">
                                <template #body="{ data }">
                                  {{ data.subjectcode }}
                                </template></Column
                              >
                              <Column field="subject" header="Subject">
                                <template #body="{ data }">
                                  {{ data.subject }}
                                </template></Column
                              >
                              <Column field="grade" header="Grade">
                                <template #body="{ data }">
                                  {{ data.grade }}
                                </template></Column
                              >
                              <Column
                                field="interpretation"
                                header="Interpretation"
                              >
                                <template #body="{ data }">
                                  {{ data.interpretation }}
                                </template></Column
                              >
                            </DataTable>
                          </div>
                        </div>
                        <hr />
                      </div>
                    </div>
                  </template>
                  <template v-if="loading">
                    <div class="p-3 text-center">
                      <ProgressSpinner style="width: 30px; height: 30px" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { defineAsyncComponent, ref } from "vue";
import { PageMixin } from "../../mixins/page.js";
import { ViewPageMixin } from "../../mixins/viewpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "viewWaecResultsPage",
  components: {},
  mixins: [PageMixin, ViewPageMixin],
  props: {
    pageName: {
      type: String,
      default: "waec_results",
    },
    idName: {
      type: String,
      default: "cindex",
    },
    routeName: {
      type: String,
      default: "waec_resultsview",
    },
    pagePath: {
      type: String,
      default: "waec_results/view",
    },
    apiPath: {
      type: String,
      default: "waec_results/view",
    },
    pageData: null,
  },
  data() {
    return {
      item: {
        default: {},
      },
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return "Examination Results";
      },
    },
    currentRecord: {
      get: function () {
        return this.$store.getters["waec_results/currentRecord"];
      },
      set: function (value) {
        this.$store.commit("waec_results/setCurrentRecord", value);
      },
    },
  },
  meta() {
    return {
      title: this.pageTitle,
    };
  },
  methods: {
    ...mapActions("waec_results", ["fetchRecord", "deleteRecord"]),
    getItems(record) {
      let items = [];
      if (record) {
        items = JSON.parse(record);
      }
      return items;
    },
  },
  watch: {
    $route(to, from) {
      //only fetch data when navigated to this page
      if (to.name == this.routeName) {
        //this.load();
      }
    },
  },
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
